import customSelect from 'custom-select';

export default class ListTeam {

    static get selector() {
        return '.team';
    }

    constructor(el) {
        this.el = el;
        this.form = el.querySelector('.team__filters');
        console.log(this.form);
        this.grid = el.querySelector('.team__list');
        this.page = 0;
        this.hasNext = true;

        this.select = customSelect(this.el.querySelectorAll('select'));

        this.setEvents();
    }

    load(callback, page) {
        this.activeLoader();

        let url = location.protocol + '//' + location.host + location.pathname;
        let formData = new FormData(this.form);
        if(page) {
            formData.append('paged', page);
        }
        
        fetch(url , {
            method: 'POST',
            body: formData,
        })
        .then((response) => {
            return response.text()
        })
        .then((html) => {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, "text/html");
            let list = doc.querySelector('.team__list');
   
            callback(list);
            this.desactiveLoader();
        })
    }

    replace(list) {
        this.grid.replaceWith(list);
        this.grid = list;

        this.addToPluton(list);

        window.dispatchEvent( new CustomEvent('inview-reload'));
    }

    add(list) {
        this.grid.dataset.currentPage = list.dataset.currentPage;
        this.grid.dataset.hasNext = list.dataset.hasNext
        //this.updatePage();
        this.addToPluton(list);

        let childs = list.children;
        Array.from(childs).forEach( child => {
            this.grid.appendChild(child);
            window.dispatchEvent( new CustomEvent('inview-reload') );
        })
    }

    addToPluton(el) {
        window.dispatchEvent( new CustomEvent('pluton-setup', {
            detail: {
                el: el
            }
        }));
    }

    activeLoader() {
        this.el.classList.add('listPartner--loading')
    }

    desactiveLoader() {
        this.el.classList.remove('listPartner--loading')
    }



    /**
     * Events
     */
    
    setEvents() {
        this.form.addEventListener('change', this.e_change.bind(this));
        this.form.addEventListener('submit', this.e_submit.bind(this));
        this.select.forEach( select => {
            select.select.addEventListener('change',this.e_change.bind(this));
        })

        //this.moreButton.addEventListener('click', this.e_more.bind(this));
    }

    /*e_more(e) {
        e.preventDefault();
        this.load(this.add.bind(this), this.page + 1);
    }*/

    e_submit(e) {
        e.preventDefault();
        this.load(this.replace.bind(this));
    }

    e_change(e) {
        console.log('change');
        e.preventDefault();
        this.load(this.replace.bind(this));
    }

}